import { gql } from '@apollo/client';

const query = gql`
  query reviews(
    $listingId: String
    $reviewState: ReviewStateRegex
    $categoryId: String
    $ratings: [Int]
    $suburbName: String
    $region: String
    $state: String
    $first: Int
    $after: String
  ) {
    reviews(
      listingId: $listingId
      reviewState: $reviewState
      categoryId: $categoryId
      ratings: $ratings
      suburbName: $suburbName
      region: $region
      state: $state
      first: $first
      after: $after
    ) {
      edges {
        node {
          id
          listingId
          rating
          displayName
          reviewState
          categoryId
          message
          suburbName
          state
          createdAt
          updatedAt
          listing {
            name
            hash
            online
            vanityUrlPath
          }
          user {
            suburb {
              name
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

module.exports = query;
